import { IMenuItem } from '../types/menu';

export const findActivetitle = (items: IMenuItem[], path: string): string | undefined => {
  for (const item of items) {
    // Check top-level path
    if (item.route === path) return item.title;

    // Check submenu items if they exist
    if (item.children) {
      const subItem = item.children.find((sub) => {
        return sub.route === path || path.includes(sub.route);
      });
      if (subItem) return subItem.title;
    }

    if (path.includes(item.route)) return item.title;
  }
  return '';
};

export const findActiveMenuItem = (
  items: IMenuItem[],
  path: string,
): IMenuItem | undefined | null => {
  for (const item of items) {
    // Check top-level path
    if (item.route === path) return item;

    // Check submenu items if they exist
    if (item.children) {
      const subItem = item.children.find((sub) => sub.route === path || path.includes(sub.route));
      if (subItem) return subItem;
    }
  }
  return null;
};
